import React from 'react';
import { GuestListTableContainer } from '../../payment/payment.style'
import { PageContainerTitleText } from '../../../../../widget/styledComponents/headings.style'
import { useState } from 'react';
import format from 'date-fns/format';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function HomeCalendar() {
  const [selected, setSelected] = useState();
  const history = useHistory()
  let footer = <p>Please pick a day.</p>;
  if (selected) {
    footer = <p>You picked {format(selected, 'PP')}.</p>;
    history.push(`/homeByDate/${format(selected, 'PP')}`);
  }
  return (
    <div>
        <GuestListTableContainer>
            <PageContainerTitleText>
              Calendar
            </PageContainerTitleText>
            <div className='row' style={{
                minHeight:"200px",


            }}>
              <DayPicker
                mode="single"
                selected={selected}
                onSelect={setSelected}
                
                footer={footer}
                style={{
                  width:"100% !important"
                }}
              />
                
            </div>

        </GuestListTableContainer>
    </div>
  )
}

export default HomeCalendar